import * as ROUTES from 'constant/routes-plcp'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import PropTypes from 'prop-types'
import * as Components from './lazy-components'

const LoggedOutRoutesPlcp = ({ location }) => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <Switch>
            <Route
              exact
              path='/mp'
              render={() => {
                return <Redirect to={ROUTES.HOME} />
              }}
            />
            <Route
              component={Components.Login}
              path={ROUTES.LOGIN}
            />
            <Redirect to={{ pathname: ROUTES.LOGIN, state: { from: location } }} />
          </Switch>
        </Col>
      </Row>
    </Container>
  )
}

LoggedOutRoutesPlcp.propTypes = {
  location: PropTypes.object
}

export default withRouter(LoggedOutRoutesPlcp)
